"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CustomizedSnackbar;
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _colors = require("@mui/material/colors");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var variantIcon = {
  error: _iconsMaterial.Error,
  info: _iconsMaterial.Info,
  success: _iconsMaterial.CheckCircle,
  warning: _iconsMaterial.Warning
};
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    error: {
      backgroundColor: theme.palette.error.dark,
      color: theme.palette.error.contrastText
    },
    icon: {
      fontSize: 20
    },
    iconVariant: {
      marginRight: theme.spacing(1),
      opacity: 0.9
    },
    info: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    message: {
      alignItems: 'center',
      display: 'flex'
    },
    success: {
      backgroundColor: _colors.green[600],
      color: theme.palette.common.white
    },
    warning: {
      backgroundColor: _colors.amber[700],
      color: theme.palette.common.white
    }
  };
});
function CustomizedSnackbar(_ref) {
  var id = _ref.id,
    message = _ref.message,
    onClose = _ref.onClose,
    open = _ref.open,
    variant = _ref.variant;
  var classes = useStyles();
  var Icon = variantIcon[variant];
  return /*#__PURE__*/_react.default.createElement(_material.Snackbar, {
    anchorOrigin: {
      horizontal: 'center',
      vertical: 'bottom'
    },
    autoHideDuration: 6000,
    id: id,
    onClose: onClose,
    open: open
  }, /*#__PURE__*/_react.default.createElement(_material.SnackbarContent, {
    action: [/*#__PURE__*/_react.default.createElement(_material.IconButton, {
      key: "close",
      "aria-label": "Close",
      color: "inherit",
      id: "".concat(id, "CloseButton"),
      onClick: onClose,
      size: "large"
    }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.Close, {
      className: classes.icon
    }))],
    "aria-describedby": "".concat(id, "Message"),
    className: (0, _clsx.default)(classes[variant]),
    id: id,
    message: /*#__PURE__*/_react.default.createElement("span", {
      className: classes.message,
      id: "".concat(id, "Message")
    }, /*#__PURE__*/_react.default.createElement(Icon, {
      className: (0, _clsx.default)(classes.icon, classes.iconVariant)
    }), message)
  }));
}